import React from 'react';
import { injectIntl } from 'react-intl';

import TextFieldDefault from './TextFieldDefault';

const MAX_LENGTH = 140;

function Title(props: any) {
  const {
    intl,
    value = '',
    label = intl.formatMessage({ id: 'POSTS.FORM.TITLE' }),
    placeholder = intl.formatMessage({ id: 'POSTS.FORM.TITLE' }),
    helperText,
    maxLength = MAX_LENGTH,
  } = props;

  let helperTextToRender;

  if (helperText) {
    helperTextToRender = `${value.length}/${maxLength} - ${helperText}`;
  } else {
    helperTextToRender = `${value.length}/${maxLength}`;
  }

  return (
    <TextFieldDefault
      {...props}
      value={value}
      label={label}
      placeholder={placeholder}
      inputProps={{ maxLength }}
      helperText={helperTextToRender}
    />
  );
}

export default injectIntl(Title);
